<div id="spinner" *ngIf="showProgressSpinner">
  <div id="spinner-wrapper"> 
      <img id="spinner-logo" src="/assets/images/pig-logo-home.png"/>
      <div id="spinner-icon">
          <mat-spinner></mat-spinner>
      </div><br />
      <div id="spinner-message">{{progressSpinnerMessage}}</div>
  </div>
</div>
